const invitations = {
  pageName: 'Convites',

  toast: {
    error: {
      default: 'Não foi possível concluir a operação.',
    },
    success: {
      delete: {
        default: 'Os convites foram excluídos com sucesso',
      },
      resend: {
        default: 'O(s) convite(s) foi/ foram reenviado/s com sucesso.',
      },
      create: {
        default: 'sucesso! Convite enviado com sucesso.',
      }
    },
  },

  table: {
    headers: {
      status: 'Status',
      email: 'E-mail',
      role: 'Função',
      invitedBy: 'Convidado por',
    },
    actions: {
      delete: 'Remover',
      resend: 'Reenviar',
    },
    filters: {
      status: 'Status',
    }
  },

  form: {
    headers: {
      personalDetails: 'Detalhes pessoais',
      roles: 'Funções de usuário',
    },
    fields: {
      firstName: 'Nome',
      lastName: 'Sobrenome',
      name: 'Nome',
      phone: 'Telefone',
      email: 'E-mail',
      role: 'Função',
      site: 'Local',
    },
    select: 'Selecione',
    buttons: {
      addAccess: 'Adicionar Local',
      sendInvitation: 'Enviar convite',
    },
  },

  deleteModal: {
    header: 'Excluir convites',
    body: 'Você está prestes a excluir {{num}} convites.',
  },

  resendModal: {
    header: 'Reenviar Convites',
    body: 'Você está prestes a reenviar {{num}} convites.',
  },

  inviteModal: {
    header: 'Convidar usuário',
    description: {
      new: 'Por favor, insira o endereço de e-mail e selecione as funções de sua preferência.',
      existing: 'Por favor, selecione os locais e as funções de sua preferência.',
    },
  },

  status: {
    pend: 'Pendente',
    accepted: 'Aceito',
    expired: 'Expirado',
  },

  isCompanyAdmin: 'Administrador de empresa',
};

export default invitations;
